import { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import BottomNav from "./BottomNav";
import InstallPrompt from "./InstallPrompt";
import OfflineBanner from "./OfflineBanner";
import SyncStatusBanner from "./SyncStatusBanner";
import LegalConsentBanner from "./LegalConsentBanner";
import ActiveRoundPill from "./ActiveRoundPill";
import WelcomeModal, { hasSeenWelcome } from "./WelcomeModal";

export default function AppShell() {
  const { user, loading } = useAuth();
  // First-time welcome — shown once per device. Wait until user is hydrated
  // so we don't flash it before redirecting unauth'd visitors to /login.
  const [showWelcome, setShowWelcome] = useState(false);
  useEffect(() => {
    if (user && !hasSeenWelcome()) {
      // Small delay so the dashboard paints first; modal then animates in.
      const t = setTimeout(() => setShowWelcome(true), 400);
      return () => clearTimeout(t);
    }
  }, [user]);
  if (loading) {
    return (
      <div className="app-shell flex items-center justify-center">
        <div className="text-[var(--primary)] font-heading text-lg">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="app-shell pb-28">
      <OfflineBanner />
      <SyncStatusBanner />
      <Outlet />
      <ActiveRoundPill />
      <BottomNav />
      <InstallPrompt />
      <LegalConsentBanner />
      {showWelcome && <WelcomeModal onClose={() => setShowWelcome(false)} />}
    </div>
  );
}
